import { createContext, useContext, useEffect, useState } from "react";
import { translations, LANGS } from "../i18n/strings";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "ar");
  const meta = LANGS.find((l) => l.code === lang) || LANGS[0];
  const dir = meta.dir;

  useEffect(() => {
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", dir);
    localStorage.setItem("lang", lang);
  }, [lang, dir]);

  const t = (key, vars) => {
    let v = translations[lang]?.[key] ?? translations.en[key] ?? key;
    if (vars && typeof v === "string") {
      v = v.replace(/\{\{(\w+)\}\}/g, (_, name) =>
        vars[name] !== undefined ? String(vars[name]) : `{{${name}}}`,
      );
    }
    return v;
  };

  return (
    <I18nContext.Provider value={{ lang, dir, t, setLang, langs: LANGS }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
